<div id="adyen-container" [ngClass]="{ 'hide-card-inputs': billingAddressOnly }"></div>
